(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dsc-e-behavior"] && !Shopify.designMode) return;
  try {
    (()=>{const config=JSON.parse(document.getElementById('EDConfig')?.textContent||'{}');const root=(config.root||'/').replace(/\/$/,'');const track=(name,data={})=>{document.dispatchEvent(new CustomEvent('dsc:analytics',{detail:{name,...data}}));try{if(window.Shopify?.analytics?.publish)window.Shopify.analytics.publish('dsc_'+name,data)}catch{}};
const notice=(message)=>{const node=document.querySelector('.ed-notice');node.replaceChildren(document.createTextNode(message+' '));const link=document.createElement('a');link.href=config.cart;link.textContent=config.viewBag;node.append(link);node.hidden=false;const close=document.createElement('button');close.type='button';close.textContent=config.continue;close.addEventListener('click',()=>node.hidden=true);node.append(close)};
document.addEventListener('click',e=>{if(e.target.closest('[data-ed-size-open]')){const opener=e.target.closest('[data-ed-size-open]');const dialog=document.querySelector('[data-ed-size-dialog]');dialog.showModal();dialog.addEventListener('close',()=>opener.focus(),{once:true})}if(e.target.closest('[data-ed-size-close]'))document.querySelector('[data-ed-size-dialog]').close();const closer=e.target.closest('[data-close-details]');if(closer){const d=closer.closest('details');d.open=false;d.querySelector('summary').focus()}const tracked=e.target.closest('[data-ed-event]');if(tracked)track(tracked.dataset.edEvent);const thumb=e.target.closest('[data-ed-thumb]');if(thumb){const frame=document.getElementById(thumb.dataset.edThumb);frame?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'nearest',inline:'start'});}const zoom=e.target.closest('[data-ed-zoom]');if(zoom){const dialog=document.querySelector('.ed-lightbox');dialog.querySelector('img').src=zoom.dataset.edZoom;dialog.showModal();dialog.addEventListener('close',()=>zoom.focus(),{once:true})}if(e.target.closest('[data-ed-zoom-close]'))document.querySelector('.ed-lightbox')?.close();});
document.addEventListener('keydown',e=>{if(e.key==='Tab'){const panel=document.querySelector('[data-ed-menu][open] .ed-drawer,[data-ed-filter][open] .ed-filter-body');if(panel){const focusable=[...panel.querySelectorAll('a[href],button,input,select,summary')].filter(el=>!el.disabled&&el.getClientRects().length);const first=focusable[0],last=focusable.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus()}}}if(e.key==='Escape')document.querySelectorAll('[data-ed-menu][open],[data-ed-search][open],[data-ed-filter][open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});
document.querySelectorAll('[data-ed-search],[data-ed-menu],[data-ed-filter]').forEach(d=>d.addEventListener('toggle',()=>{if(d.open){document.querySelectorAll('[data-ed-search][open],[data-ed-menu][open],[data-ed-filter][open]').forEach(other=>{if(other!==d)other.open=false});d.querySelector('input,button')?.focus()}}));
document.addEventListener('invalid',e=>{if(e.target.matches('[data-ed-purchase] input[name=id],input[name=id][form]')){const form=e.target.form;const message=form?.dataset.optionError||config.chooseOption||'Please select an available option before continuing.';e.target.setCustomValidity(message);const error=form?.querySelector('[data-ed-error]');if(error){error.textContent=message;error.hidden=false}const first=[...(form?.elements||[])].find(input=>input.name==='id'&&!input.disabled);first?.focus();}},true);
document.addEventListener('change',e=>{if(e.target.matches('[data-ed-sort]'))e.target.form.submit();if(e.target.matches('.ed-product-form input[name=id]')){const form=e.target.form;[...form.elements].filter(input=>input.name==='id').forEach(input=>input.setCustomValidity(''));const error=form.querySelector('[data-ed-error]');if(error)error.hidden=true;const stock=form.querySelector('[data-ed-stock]');if(stock)stock.textContent=e.target.dataset.stock==='available'?config.available:e.target.dataset.stock+' '+config.availableCount;const product=form.closest('[data-ed-product]');if(product){const delivered=product.querySelector('[data-ed-delivered]');if(delivered&&e.target.dataset.priceCents){const cents=Number(e.target.dataset.priceCents);delivered.textContent='Rs.'+((cents+(cents>350000?0:30000))/100).toLocaleString('en-PK',{maximumFractionDigits:2})}const sku=product.querySelector('[data-ed-sku]');if(sku)sku.textContent=e.target.dataset.sku;const help=product.querySelector('[data-ed-product-help]');if(help){const link=new URL(help.href);link.searchParams.set('text','Hi, I would like information about '+help.dataset.productTitle+' (SKU '+e.target.dataset.sku+', '+form.dataset.optionLabel+': '+e.target.dataset.title+'). '+location.origin+location.pathname+'?variant='+e.target.value);help.href=link.href}const media=product.querySelector('.ed-gallery-frame[data-media-id="'+e.target.dataset.mediaId+'"]');if(media){const track=product.querySelector('.ed-gallery-track');if(track)track.scrollTo({left:media.offsetLeft-track.firstElementChild.offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}const price=product.querySelector('[data-ed-price] .ed-price');price.replaceChildren();const current=document.createElement('span');current.textContent=e.target.dataset.price;price.append(current);if(e.target.dataset.compare){const was=document.createElement('s');was.textContent=e.target.dataset.compare;price.append(was)}const size=document.querySelector('[data-ed-sticky-size]');if(size)size.textContent=e.target.dataset.title;const sticky=document.querySelector('[data-ed-sticky-price]');if(sticky)sticky.textContent=e.target.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',e.target.value);history.replaceState({},'',url)}}});
document.addEventListener('submit',async e=>{const form=e.target;if(!form.matches('[data-ed-purchase]'))return;e.preventDefault();if(form.dataset.busy)return;const submitter=e.submitter;let leaving=false;const data=new FormData(form);if(!data.get('id')){const first=[...form.elements].find(input=>input.name==='id'&&!input.disabled);first?.focus();form.reportValidity();return}const error=form.querySelector('[data-ed-error]');error.hidden=true;form.dataset.busy='true';const buttons=[...form.elements].filter(el=>el.tagName==='BUTTON'&&el.type==='submit');const buttonStates=buttons.map(button=>[button,button.disabled]);buttons.forEach(b=>{b.dataset.purchaseDisabledBefore=String(b.disabled);b.disabled=true});form.setAttribute('aria-busy','true');window.dscParcelOpening?.setPurchaseBusy(true);try{const response=await fetch(root+'/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});const result=await response.json();if(!response.ok)throw new Error(result.description||config.failed);track('add_to_cart',{product_id:form.dataset.productId,variant_id:data.get('id'),quantity:Number(data.get('quantity')||1)});if(submitter?.value==='/checkout'){track('begin_checkout',{product_id:form.dataset.productId});leaving=true;location.assign(root+'/checkout');return}const cartResponse=await fetch(root+'/cart.js');if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-ed-count]').forEach(b=>{b.textContent=cart.item_count;b.hidden=cart.item_count===0})}notice(config.added+' — '+result.product_title+(result.variant_title&&result.variant_title!=='Default Title'?' / '+result.variant_title:''))}catch(err){error.textContent=err.message||config.failed;error.hidden=false}finally{if(!leaving){window.dscParcelOpening?.setPurchaseBusy(false);delete form.dataset.busy;form.removeAttribute('aria-busy');buttonStates.forEach(([button,disabled])=>{button.disabled=disabled;delete button.dataset.purchaseDisabledBefore})}}});
const search=document.querySelector('[data-ed-predictive]');if(search){let timer,controller;search.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();const target=document.getElementById(search.getAttribute('aria-controls'));target.replaceChildren();search.setAttribute('aria-expanded','false');if(search.value.trim().length<2)return;timer=setTimeout(async()=>{controller=new AbortController();try{const query=new URLSearchParams({q:search.value.trim(),'resources[type]':'product','resources[limit]':'5','resources[options][fields]':'title,product_type,variants.title,vendor,variants.sku,body'});const res=await fetch(root+'/search/suggest.json?'+query,{signal:controller.signal});if(!res.ok)return;const data=await res.json();for(const item of data.resources.results.products){const a=document.createElement('a');a.href=item.url;const img=document.createElement('img');img.src=item.image;img.alt='';img.width=45;img.height=60;const p=document.createElement('p');p.textContent=item.title;a.append(img,p);target.append(a)}search.setAttribute('aria-expanded',target.childElementCount?'true':'false')}catch{ }},250)})}
document.querySelectorAll('.ed-nav>.ed-department').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)document.querySelectorAll('.ed-nav>.ed-department[open]').forEach(other=>{if(other!==d)other.open=false})}));document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.ed-nav>.ed-department[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});document.addEventListener('click',e=>{if(!e.target.closest('.ed-nav'))document.querySelectorAll('.ed-nav>.ed-department[open]').forEach(d=>d.open=false)});const initSizeFilter = scope => {
  const control = scope.querySelector('[data-ed-size-filter]');
  if (!control || control.dataset.sizeReady) return;
  control.dataset.sizeReady = 'true';
  const cards = [...scope.querySelectorAll('.ed-grid > [data-ed-sizes]')];
  const count = scope.querySelector('[data-ed-size-count]');
  const empty = scope.querySelector('[data-ed-size-empty]');
  const forms = [...scope.querySelectorAll('form[method="get"]')];
  const apply = updateUrl => {
    const size = control.value;
    let matches = 0;
    cards.forEach(card => {
      const match = !size || card.dataset.edSizes.split('|').map(value => value.trim()).includes(size);
      card.hidden = !match;
      if (match) matches++;
    });
    if (count) count.textContent = matches;
    if (empty) empty.hidden = matches !== 0;
    forms.forEach(form => {
      let input = form.querySelector('input[name="dsc_size"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'dsc_size';
        form.append(input);
      }
      input.value = size;
      input.disabled = !size;
    });
    if (updateUrl) {
      const url = new URL(location.href);
      if (size) url.searchParams.set('dsc_size', size);
      else url.searchParams.delete('dsc_size');
      history.replaceState(history.state, '', url);
    }
  };
  const restore = () => {
    const selected = new URL(location.href).searchParams.get('dsc_size') || '';
    control.value = [...control.options].some(option => option.value === selected) ? selected : '';
    apply(false);
  };
  control.addEventListener('change', () => apply(true));
  window.addEventListener('pageshow', restore);
  restore();
};
document.querySelectorAll('.ed-collection').forEach(initSizeFilter);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ed-collection').forEach(initSizeFilter));

const initCampaigns=(scope)=>scope.querySelectorAll('[data-ed-campaign]').forEach(c=>{if(c.dataset.ready)return;c.dataset.ready='true';const slides=[...c.querySelectorAll('[data-ed-slide]')];const buttons=[...c.querySelectorAll('[data-ed-slide-index]')];let index=0;const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==index);buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)))};buttons.forEach((b,i)=>b.addEventListener('click',()=>show(i)));let start;c.addEventListener('touchstart',e=>{start=e.changedTouches[0].clientX},{passive:true});c.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-start;if(Math.abs(delta)>60)show(index+(delta<0?1:-1))},{passive:true})});initCampaigns(document);document.addEventListener('shopify:section:load',e=>initCampaigns(e.target));
document.querySelectorAll('.ed-product-form input[name=id]:checked').forEach(input=>input.dispatchEvent(new Event('change',{bubbles:true})));
window.addEventListener('pageshow',event=>{if(!event.persisted)return;document.querySelectorAll('[data-ed-purchase][data-busy]').forEach(form=>{delete form.dataset.busy;form.removeAttribute('aria-busy');[...form.elements].filter(el=>el.dataset?.purchaseDisabledBefore!==undefined).forEach(button=>{button.disabled=button.dataset.purchaseDisabledBefore==='true';delete button.dataset.purchaseDisabledBefore})})});
let cartBusy=false,cartDirty=false,cartTimer;
document.addEventListener('input',e=>{if(e.target.matches('[data-cart-quantity]')){clearTimeout(cartTimer);const input=e.target;cartTimer=setTimeout(()=>{if(input.isConnected&&!cartBusy)input.dispatchEvent(new Event('change',{bubbles:true}))},350);cartDirty=true;document.querySelector('[name=checkout]')?.setAttribute('disabled','disabled')}});
document.addEventListener('submit',e=>{if(e.target.id==='CartForm'&&(cartBusy||cartDirty)){e.preventDefault();const q=e.target.querySelector('[data-cart-quantity]:focus');q?.blur()}});
document.addEventListener('change',async e=>{if(!e.target.matches('[data-cart-quantity],[data-cart-variant]'))return;const section=e.target.closest('[data-ed-cart-section]');if(cartBusy)return;clearTimeout(cartTimer);const row=e.target.closest('[data-cart-key]');const quantity=row.querySelector('[data-cart-quantity]');if(!quantity.checkValidity()){quantity.reportValidity();return}cartBusy=true;const status=section.querySelector('[data-cart-status]');status.textContent=section.dataset.saving;section.querySelectorAll('button,input,select').forEach(el=>el.disabled=true);try{let endpoint='/cart/change.js';let body={id:row.dataset.cartKey,quantity:Number(quantity.value)};if(e.target.matches('[data-cart-variant]')){const check=await fetch(root+'/cart.js');if(!check.ok)throw Error();const cart=await check.json();const original=cart.items.find(i=>i.key===row.dataset.cartKey);if(!original)throw Error();const target=cart.items.find(i=>String(i.variant_id)===e.target.value&&!i.selling_plan_allocation&&Object.keys(i.properties||{}).length===0);endpoint='/cart/update.js';body={updates:{[original.key]:0,[target?.key||e.target.value]:Number(quantity.value)+(target?.quantity||0)}}}const res=await fetch(root+endpoint,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});const data=await res.json();if(!res.ok)throw Error(data.description||section.dataset.failed);const url=new URL(location.href);url.searchParams.set('section_id',section.dataset.edCartSection);const html=await fetch(url);if(!html.ok)throw Error(section.dataset.failed);const doc=new DOMParser().parseFromString(await html.text(),'text/html');const replacement=doc.querySelector('[data-ed-cart-section]');if(!replacement)throw Error(section.dataset.failed);section.replaceWith(replacement);replacement.querySelector('[data-cart-status]')?.append(document.createTextNode(replacement.dataset.saved));document.querySelectorAll('[data-ed-count]').forEach(el=>{el.textContent=data.item_count;el.hidden=!data.item_count});cartDirty=false}catch(err){status.textContent=err.message||section.dataset.failed;section.querySelectorAll('button,input,select').forEach(el=>el.disabled=false);section.querySelector('[name=checkout]')?.setAttribute('disabled','disabled')}finally{cartBusy=false}});

// Product-specific chart: exact source measurements, native modal focus and selected-size context.
const chartSizeKey=value=>String(value||'').trim().toUpperCase().replace(/^MEDIUM$/,'M').replace(/^LARGE$/,'L').replace(/^XXL$/,'2XL');
document.addEventListener('click',event=>{
 const opener=event.target.closest('[data-ed-chart-open]');
 if(opener){
  const dialog=document.getElementById(opener.getAttribute('aria-controls'));
  if(!dialog||dialog.open)return;
  const selected=opener.closest('form')?.querySelector('input[name="id"]:checked');
  const names=String(selected?.dataset.title||'').split('/').map(chartSizeKey);
  dialog.querySelectorAll('thead th').forEach(cell=>cell.scope='col');
  dialog.querySelectorAll('tbody tr').forEach(row=>{
   const cell=row.querySelector('th');if(cell)cell.scope='row';
   const active=names.includes(chartSizeKey(cell?.textContent));
   row.classList.toggle('is-selected',active);
   if(active)row.setAttribute('aria-current','true');else row.removeAttribute('aria-current');
  });
  const status=dialog.querySelector('[data-ed-chart-selection]');
  status.textContent=selected?'Selected size: '+selected.dataset.title:'Compare with a garment that fits you comfortably.';
  document.body.classList.add('dsc-chart-open');
  dialog.addEventListener('close',()=>{document.body.classList.remove('dsc-chart-open');opener.focus();},{once:true});
  dialog.showModal();dialog.querySelector('[data-ed-chart-close]').focus();
 }
 const closer=event.target.closest('[data-ed-chart-close]');
 if(closer)closer.closest('dialog').close();
});
document.addEventListener('keydown',event=>{
 if(event.key!=='Tab')return;
 const dialog=document.querySelector('[data-ed-chart-dialog][open]');if(!dialog)return;
 const controls=[...dialog.querySelectorAll('button,a[href],input,select,textarea,[tabindex="0"]')].filter(el=>!el.disabled&&el.getClientRects().length);
 const first=controls[0],last=controls.at(-1);
 if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
 else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dsc-e-fragrance-system"] && !Shopify.designMode) return;
  try {
    (()=>{const scope=document.querySelector('[data-fragrance-catalog]');if(!scope)return;const grid=scope.querySelector('[data-fragrance-grid]'),cards=[...grid.querySelectorAll('[data-fragrance-title]')],search=scope.querySelector('[data-fragrance-search]'),audience=scope.querySelector('[data-fragrance-audience]'),kind=scope.querySelector('[data-fragrance-kind]'),sort=scope.querySelector('[data-fragrance-sort]');const chosen=new URL(location.href).searchParams.get('audience');if(['Men','Women','Unisex'].includes(chosen))audience.value=chosen;const apply=()=>{let count=0;const list=sort.value==='featured'?[...cards]:[...cards].sort((a,b)=>(Number(a.dataset.fragrancePrice)-Number(b.dataset.fragrancePrice))*(sort.value==='high'?-1:1));for(const card of list){card.hidden=Boolean((audience.value&&card.dataset.fragranceGender!==audience.value)||(kind.value&&card.dataset.fragranceType!==kind.value)||(search.value.trim()&&!card.dataset.fragranceTitle.includes(search.value.trim().toLowerCase())));if(!card.hidden)count++;grid.append(card)}scope.querySelector('[data-fragrance-count]').textContent=String(count)+' / '+cards.length;scope.querySelector('[data-fragrance-empty]').hidden=count!==0};scope.querySelectorAll('input,select').forEach(el=>el.addEventListener(el.tagName==='INPUT'?'input':'change',apply));apply()})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dsc-home-carousel-controls"] && !Shopify.designMode) return;
  try {
    function initDscCarousels(root=document){
root.querySelectorAll('[data-dsc-carousel]').forEach(section=>{
if(section.dataset.dscReady)return;
const track=section.querySelector('[data-dsc-track]'),prev=section.querySelector('[data-dsc-prev]'),next=section.querySelector('[data-dsc-next]'),count=section.querySelector('[data-dsc-count]');
if(!track||!prev||!next||!track.children.length)return;
section.dataset.dscReady='true';
const cards=Array.from(track.children);
const position=()=>Math.round(track.scrollLeft/(cards[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0)));
const update=()=>{const index=Math.min(cards.length-1,position());count.textContent=String(index+1).padStart(2,'0')+' / '+String(cards.length).padStart(2,'0');prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
const move=direction=>{const index=Math.max(0,Math.min(cards.length-1,position()+direction));const x=cards[index].offsetLeft-cards[0].offsetLeft;track.scrollTo({left:x,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
});}
initDscCarousels();document.addEventListener('shopify:section:load',()=>initDscCarousels());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dsc-parcel-opening"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('dsc-parcel-opening')) return;
  const first = document.querySelector('dsc-parcel-opening');
  if (!first) return;
  const root = (first.dataset.root || '/').replace(/\/$/, '');
  const controls = new Set();
  let requested = first.dataset.selected === 'true';
  let saved = requested;
  let pending = null;
  let failed = false;
  let touched = false;
  let purchaseBusy = 0;
  let revision = 0;
  const render = () => controls.forEach(control => {
    control.querySelector('[data-parcel-toggle]').checked = requested;
    control.querySelector('[data-parcel-toggle]').disabled = Boolean(pending) || purchaseBusy > 0;
    const button = control.querySelector('[data-parcel-button]');
    if (button) {
      button.setAttribute('aria-pressed', String(requested));
      button.disabled = Boolean(pending) || purchaseBusy > 0;
    }
    control.setAttribute('aria-busy', String(Boolean(pending)));
    control.dataset.error = String(failed);
    control.querySelector('[data-parcel-retry]').hidden = !failed;
    control.querySelector('[data-parcel-status]').textContent = pending ? control.dataset.saving : failed ? control.dataset.failed : touched ? requested ? control.dataset.saved : control.dataset.cleared : '';
  });
  window.dscParcelOpening = {setPurchaseBusy(busy) { purchaseBusy = Math.max(0, purchaseBusy + (busy ? 1 : -1)); render(); }};
  const save = () => {
    if (pending) return pending;
    if (!failed && requested === saved) return Promise.resolve();
    const target = requested;
    failed = false;
    pending = (async () => {
      const response = await fetch(root + '/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: {'Allow parcel opening': target ? 'Requested' : 'Not requested'}})
      });
      const cart = await response.json();
      if (!response.ok || cart.attributes?.['Allow parcel opening'] !== (target ? 'Requested' : 'Not requested')) throw new Error('Parcel request could not be saved');
      saved = target;
    })().catch(error => { failed = true; throw error; }).finally(() => { pending = null; render(); });
    render();
    return pending;
  };
  class ParcelOpening extends HTMLElement {
    connectedCallback() {
      if (controls.has(this)) return;
      controls.add(this);
      this.hidden = false;
      if (!this.dataset.initialized) {
        this.dataset.initialized = 'true';
        const choose = value => {
          revision += 1;
          requested = value;
          touched = true;
          save().catch(() => {});
          render();
        };
        this.querySelector('[data-parcel-toggle]').addEventListener('change', event => choose(event.target.checked));
        this.querySelector('[data-parcel-button]')?.addEventListener('click', () => choose(!requested));
        this.querySelector('[data-parcel-retry]').addEventListener('click', () => save().catch(() => {}));
      }
      render();
    }
    disconnectedCallback() { controls.delete(this); }
  }
  customElements.define('dsc-parcel-opening', ParcelOpening);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-ed-purchase],#CartForm') || (!pending && !failed && requested === saved)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.parcelWaiting) return;
    form.dataset.parcelWaiting = 'true';
    const submitter = event.submitter;
    try {
      await save();
      delete form.dataset.parcelWaiting;
      if (form.isConnected) form.requestSubmit(submitter?.isConnected && !submitter.disabled ? submitter : undefined);
    } catch {
      delete form.dataset.parcelWaiting;
      (form.querySelector('[data-parcel-retry]') || form.closest('[data-ed-product]')?.querySelector('[data-parcel-retry]:not([hidden])') || document.querySelector('[data-parcel-retry]:not([hidden])'))?.focus();
    }
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || (!pending && !failed && requested === saved)) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !/\/checkout\/?$/.test(destination.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try { await save(); location.assign(destination.href); } catch { document.querySelector('[data-parcel-retry]:not([hidden])')?.focus(); }
  }, true);
  window.addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    purchaseBusy = 0;
    render();
    if (pending || failed) return;
    const readRevision = revision;
    try {
      const response = await fetch(root + '/cart.js', {headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (pending || failed || readRevision !== revision) return;
      requested = saved = cart.attributes?.['Allow parcel opening'] === 'Requested';
      touched = false;
      render();
    } catch {}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
